const PLAN_FORM_ORIGIN = 'https://forms.thebookcove.com';
const PLAN_FORM_MESSAGE = 'plan:public-form:resize';
const MIN_FORM_HEIGHT = 200;
const MAX_FORM_HEIGHT = 5000;

window.addEventListener('message', (event) => {
  if (event.origin !== PLAN_FORM_ORIGIN || event.data?.type !== PLAN_FORM_MESSAGE) return;

  const height = Number(event.data.height);
  if (!Number.isFinite(height)) return;

  const iframe = Array.from(document.querySelectorAll('iframe[data-plan-form]')).find(
    (candidate) => candidate.contentWindow === event.source
  );
  if (!iframe) return;

  iframe.style.height = `${Math.min(MAX_FORM_HEIGHT, Math.max(MIN_FORM_HEIGHT, Math.ceil(height)))}px`;
});
